
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface NewsletterState {
  isLoading: boolean;
  isSubscribed: boolean;
  message: string;
}

export const useNewsletter = () => {
  const [state, setState] = useState<NewsletterState>({
    isLoading: false,
    isSubscribed: false,
    message: ""
  });

  const subscribe = async (email: string) => {
    if (!email) {
      toast.error("Veuillez entrer une adresse email");
      return false;
    }

    // Validation côté client
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Veuillez entrer une adresse email valide");
      return false;
    }

    setState(prev => ({ ...prev, isLoading: true, message: "" }));

    try {
      console.log("Inscription à la newsletter pour:", email);

      const { data, error } = await supabase.functions.invoke('newsletter-subscription', {
        body: {
          email: email.toLowerCase(),
          action: 'subscribe'
        }
      });

      if (error) {
        console.error("Erreur Supabase:", error);
        throw new Error(error.message || "Erreur lors de l'inscription");
      }

      if (!data?.success) {
        throw new Error(data?.error || "L'inscription a échoué");
      }

      console.log("Inscription réussie:", data);
      
      setState(prev => ({ 
        ...prev, 
        isSubscribed: true, 
        message: data.message || "Inscription réussie!"
      }));

      if (data.alreadySubscribed) {
        toast.info(data.message);
      } else {
        toast.success(data.message);
      }

      return true;

    } catch (error: any) {
      console.error("Erreur lors de l'inscription:", error);
      const errorMessage = error.message || "Erreur lors de l'inscription à la newsletter";
      
      setState(prev => ({ ...prev, message: errorMessage }));
      toast.error(errorMessage);
      
      return false;
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const resetState = () => {
    setState({
      isLoading: false,
      isSubscribed: false,
      message: ""
    });
  };

  return {
    ...state,
    subscribe,
    resetState
  };
};
